import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledWidgetMini = styled.div`
  position: relative;
  margin: ${rem('7px')};
  flex: 1;
  width: 50%;
  display: flex;
  flex-direction: column;
  background-color: ${props => {
    switch (props.type) {
      case 'traffic':
        return `${props.theme.colors.colorTwo}`;

      case 'weather':
        return `${props.theme.colors.colorOne}`;

      case 'calendar':
        return `${props.theme.colors.colorFour}`;

      default:
        return `${props.theme.colors.primary}`;
    }
  }};
  ${mediaqueries.greaterThan('mobile')`
    margin: ${rem('15px')};
  `};
`;

const StyledWrapTitle = styled.div`
  background-color: ${props => props.theme.colors.dark}1A;
  padding: ${rem('13px')} 0 ${rem('11px')} 0;
  position: relative;
  text-align: center;
  width: 100%;
`;

const StyledTitle = styled.h3`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  margin: 0;
  line-height: 1;
  text-transform: uppercase;
`;

const StyleUpdate = styled.div`
  bottom: 0;
  font-size: ${rem('11px')};
  position: absolute;
  right: ${rem('7px')};
  text-align: right;
`;

const StyleUpdateIcon = styled(Icon)`
  float: right;
  margin: 0.1rem 0 0.1rem 0.5rem;
  &:hover {
    fill: ${props => props.theme.colors.light};
  }
`;

const StyleIcon = styled(Icon)`
  position: absolute;
  right: ${rem('10px')};
  top: 50%;
  margin-top: ${rem('-8px')};
  &:hover {
    fill: ${props => props.theme.colors.light};
  }
`;

const StyleConfigWrap = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: ${rem('20px')} ${rem('10px')};
`;

const StyleConfigText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  margin: 0;
`;

const StyleConfigIconRight = styled(Icon)`
  &:hover {
    fill: ${props => props.theme.colors.light};
  }
`;

const StyleConfigIconLeft = styled(Icon)`
  transform: rotate(180deg);
  &:hover {
    fill: ${props => props.theme.colors.light};
  }
`;

export {
  StyleConfigIconLeft,
  StyleConfigIconRight,
  StyleConfigText,
  StyleConfigWrap,
  StyleIcon,
  StyleUpdate,
  StyleUpdateIcon,
  StyledTitle,
  StyledWidgetMini,
  StyledWrapTitle
};
